import { format } from 'date-fns';
import cookies from 'js-cookie';
import router from '@/router';
import store from '@/store';
import servers from '@/configs/servers';
import { post } from '@/assets/js/http';
import { isUCLoggedIn } from '@/assets/js/uc';
import API from '@/configs/api';

// 当前环境的server
const server = servers[location.hostname] || servers['openapi.huoyunren.com'];

let _checkLoginPromise = null;
function checkLogin() {
    let userinfo;
    try {
        userinfo = JSON.parse(decodeURIComponent(cookies.get('U')));
    } catch (e) { }
    if (!_checkLoginPromise && userinfo && !['cyt', 'e6'].includes(userinfo.source) && !isUCLoggedIn()) {
        _checkLoginPromise = new Promise((resolve) => {
            window.GUcenter.isLogin({
                env: server.env,
                appCode: 'openapi',
                callback(result) {
                    store.commit('setLoginStatus', result.success);
                    // 如果已经登录，解析用户信息
                    if (result.success) {
                        if (userinfo) {
                            store.commit('updateUserInfo', {
                                username: userinfo.uname,
                            });
                        } else {
                            toLogout();
                        }
                        // 已经登录的用户，需要先手动初始化配置
                        post(API.user.checkUser).then((checkUserResult) => {
                            resolve(result.success);
                        });
                        resolve(result.success);
                    } else {
                        resolve();
                    }
                },
            });
        });
    } else {
        _checkLoginPromise = new Promise(async (resolve) => {
            if (userinfo) {
                // 已经登录的用户，需要先手动初始化配置
                const d = await post(API.user.checkUser).catch((error) => {
                    cookies.remove('U');
                    cookies.remove('X-G7-Userinfo');
                    cookies.remove('Token');
                    store.commit('setLoginStatus', false);
                    resolve();
                });
                if (d) {
                    store.commit('setLoginStatus', true);
                    store.commit('updateUserInfo', userinfo);
                    resolve(true);
                } else {
                    cookies.remove('U');
                    cookies.remove('X-G7-Userinfo');
                    cookies.remove('Token');
                    store.commit('setLoginStatus', false);
                    resolve();
                }
            } else {
                cookies.remove('U');
                cookies.remove('X-G7-Userinfo');
                cookies.remove('Token');
                store.commit('setLoginStatus', false);
            }
            resolve();
        });
    }
    return _checkLoginPromise;
}

function needLogin(path) {
    return path === '/productCenter/pushApi/apply'
        || path === '/productCenter/restApi/apply'
        || path.startsWith('/console');
}

function toLogin(type) {
    const callbackUrl = encodeURIComponent(`${window.location.href}`);
    if (type === 'G7') {
        location.href = `${server.ucenterLoginUrl}?callback=${callbackUrl}&appcode=openapi`;
    } else if (type === 'BMS') {
        router.push({
            path: '/bmsLogin',
            query: {
                callback: callbackUrl
            }
        });
    }else if (type === 'E6') {
        router.push({
            path: '/e6Login',
            query: {
                callback: callbackUrl
            }
        });
    }
}

function toPhone() {
    const callbackUrl = encodeURIComponent(`${window.location.protocol}//${window.location.hostname}/#/index`);
    window.openNew(`${server.ucenterPhoneUrl}?callback=${callbackUrl}&appcode=openapi`);
}

function toEmail() {
    const callbackUrl = encodeURIComponent(`${window.location.protocol}//${window.location.hostname}/#/index`);
    window.openNew(`${server.ucenterEmailUrl}?callback=${callbackUrl}&appcode=openapi`);
}

function toLogout() {
    // 使用sdk登出
    return new Promise((resolve) => {
        window.GUcenter.logout({
            env: server.env,
            callback(result) {
                if (result.success) {
                    _checkLoginPromise = null;
                    resolve();
                }
            },
        });
    });
}

function toIndex() {
    const logouturl = cookies.get('logouturl');
    const lastHash = location.hash.slice(1);
    cookies.set('lastHash', lastHash);

    if (logouturl) {
        location.href = logouturl;
    } else {
        router.push('/index');
    }
}

// 对enums数据转换 enums：[{}]
function transEnums(text = '', enums = [{}]) {
    const findItem = enums.find(item => `${item.value}` === `${text}`);

    if (findItem === undefined) return text;

    return findItem.label;
}

// 时间戳转换成字符串格式
function formatDate(date = 0, fmt = 'YYYY-MM-DD HH:mm:ss') {
    return date ? format(new Date(date), fmt) : '-';
}

// 对url后面的参数encodeURI()转码
function queryEncodeUri(defaultQuery = {}) {
    const query = {};

    Object.keys(defaultQuery).forEach(item => query[item] = encodeURI(defaultQuery[item]));

    return query;
}

// 对url后面的参数decodeURI()解码
function queryDecodeUri(defaultQuery = {}) {
    const query = {};

    Object.keys(defaultQuery).forEach(item => query[item] = decodeURI(defaultQuery[item]));

    return query;
}
function sortData(data) {
    if (typeof data !== 'object') return;
    const keysArr = Object.keys(data).sort();
    const newData = {};
    keysArr.forEach((item) => {
        console.log(item);
        newData[`${item}`] = data[`${item}`];
        if (typeof newData[`${item}`] === 'object' && Object.keys(newData[`${item}`]).length > 0) {
            newData[`${item}`] = sortData(newData[`${item}`]);
        }
    });
    return newData;
}
export default {
    install(Vue) {
        // pub共用模块
        Vue.$pub = Vue.prototype.$pub = {
            env: location.hostname.split('.')[0],
            toLogin,
            toIndex,
            transEnums,
            formatDate,
            queryEncodeUri,
            queryDecodeUri,
            sortData,
            checkLogin,
            toLogout,
            toPhone,
            toEmail,
            needLogin,
        };
    },
};

export {
    toLogin,
    toLogout,
    toIndex,
    transEnums,
    formatDate,
    queryEncodeUri,
    queryDecodeUri,
    sortData,
    checkLogin,
    toPhone,
    toEmail,
    needLogin,
};



// WEBPACK FOOTER //
// ./src/assets/js/pub.js